import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GlobalSearchResult } from "@/api/williams/search";
import { QualifierUser } from "@/api/user";
import { SpinButton } from "@/components/form/SpinButton";
import { TransferItems } from "./TransferItems";
import { useModalDialog } from "@/hooks";
import { UserSelectionDialog } from "../../dialogs/UserSelection";
import { useState } from "react";
import { useTransferSpecialist } from "../../hooks";

export type TransferFormProps = {
  user: QualifierUser;
};

export function TransferForm({ user }: TransferFormProps) {
  const [transferFrom, setTransferFrom] = useState(user);
  const [transferTo, setTransferTo] = useState<QualifierUser>();
  const [selectedItems, setSelectedItems] = useState<GlobalSearchResult[]>([]);

  const modal = useModalDialog();
  const transfer = useTransferSpecialist();

  function handleTransfer() {
    if (transferTo) {
      transfer.mutate({ transferFrom, transferTo, items: selectedItems });
      setSelectedItems([]);
    }
  }

  function handleSelectFrom() {
    modal.show(UserSelectionDialog, {
      initialUser: transferFrom,
      onAccept: (user) => {
        setTransferFrom(user);
        setSelectedItems([]);
      },
    });
  }

  function handleSelectTo() {
    modal.show(UserSelectionDialog, {
      initialUser: transferTo,
      onAccept: (user) => {
        setTransferTo(user);
      },
    });
  }

  return (
    <div className="mb-5" style={{ maxWidth: 1000 }}>
      <h3>Reassign Specialist</h3>
      <form>
        <div className="row mt-2">
          <div className="col-lg-5">
            {/* Reassign From */}
            <div>
              <label htmlFor="from" className="col-form-label pb-0">
                Reassign From <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input type="text" className="form-control" value={transferFrom.name} readOnly />
                <span className="input-group-text" role="button" onClick={handleSelectFrom}>
                  <FontAwesomeIcon size="sm" icon={faMagnifyingGlass} title="Search" />
                </span>
              </div>
            </div>
            {/* Reassign To */}
            <div>
              <label htmlFor="to" className="col-form-label pb-0">
                Reassign To <span className="text-danger">*</span>
              </label>
              <div className="input-group mb-2">
                <input type="text" className="form-control" value={transferTo?.name} readOnly />
                <span className="input-group-text" role="button" onClick={handleSelectTo}>
                  <FontAwesomeIcon size="sm" icon={faMagnifyingGlass} title="Search" />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <TransferItems
            transferFrom={transferFrom}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
          />
        </div>

        <SpinButton
          type="button"
          className="btn btn-default mt-3 mb-4"
          onClick={handleTransfer}
          disabled={!transferTo || selectedItems.length === 0 || transfer.isLoading}
          loading={transfer.isLoading}
        >
          Reassign Selected
        </SpinButton>
      </form>
    </div>
  );
}
